import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useStoreActions, useStore } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
export const useInvoice = function useInvoice(invoiceId) {
    let { enabled = true, refreshOnHookMount = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const isVendor = useStore(selectors.user.isVendor);
    const { data, isLoading, refresh } = useQueryState({
        queryKey: [
            QueryKeys.Invoice,
            invoiceId
        ],
        queryFn: ()=>api.invoice.getByID(invoiceId, !isVendor),
        enabled: enabled && !!invoiceId,
        refreshOnHookMount
    });
    return {
        invoice: data,
        isLoading,
        refresh
    };
};
export const useGetInvoice = ()=>{
    const { api } = useStoreActions();
    const isVendor = useStore(selectors.user.isVendor);
    const queryClient = useQueryClient();
    return useCallback((invoiceId)=>queryClient.fetchQuery({
            queryKey: [
                QueryKeys.Invoice,
                invoiceId
            ],
            queryFn: ()=>api.invoice.getByID(invoiceId, !isVendor)
        }), [
        api,
        isVendor,
        queryClient
    ]);
};
